<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="回收类型：">
              <el-radio-group
                v-model="tableFrom.product_deposit"
                type="button"
                @change="getList(1)"
              >
                <el-radio-button label=""
                  >全部
                  {{ "(" + orderChartType.all ? orderChartType.all : 0 + ")" }}
                </el-radio-button>
                <el-radio-button label="2"
                  >有寄存
                  {{
                    "(" + orderChartType.deposit_num
                      ? orderChartType.deposit_num
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="1"
                  >普通回收
                  {{
                    "(" + orderChartType.ordinary_num
                      ? orderChartType.ordinary_num
                      : 0 + ")"
                  }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="订单状态：">
              <el-radio-group
                v-model="tableFrom.status"
                type="button"
                @change="getList(1)"
              >
                <el-radio-button label=""
                  >全部
                  {{ "(" + orderChartType.all ? orderChartType.all : 0 + ")" }}
                </el-radio-button>
                <el-radio-button label="0"
                  >已提交
                  {{
                    "(" + orderChartType.submit
                      ? orderChartType.submit
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="1"
                  >已入库
                  {{
                    "(" + orderChartType.complete
                      ? orderChartType.complete
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="2000"
                  >待结算
                  {{
                    "(" + orderChartType.noSett
                      ? orderChartType.noSett
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="2"
                  >已完成
                  {{
                    "(" + orderChartType.success
                      ? orderChartType.success
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="-2"
                  >回收失败
                  {{
                    "(" + orderChartType.fail ? orderChartType.fail : 0 + ")"
                  }}
                </el-radio-button>
                <!--                <el-radio-button label="-1"-->
                <!--                  >已取消-->
                <!--                  {{-->
                <!--                    "(" + orderChartType.cancel-->
                <!--                      ? orderChartType.cancel-->
                <!--                      : 0 + ")"-->
                <!--                  }}-->
                <!--                </el-radio-button>-->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="商品状态：">
              <el-radio-group
                v-model="tableFrom.is_worn"
                type="button"
                @change="getList(1)"
              >
                <el-radio-button label=""
                  >全部
                  {{ "(" + orderChartType.all ? orderChartType.all : 0 + ")" }}
                </el-radio-button>
                <el-radio-button label="0"
                  >正常
                  {{
                    "(" + orderChartType.noWorn
                      ? orderChartType.noWorn
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="1"
                  >有异常
                  {{
                    "(" + orderChartType.yesWorn
                      ? orderChartType.yesWorn
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="2"
                  >异常申请退回
                  {{
                    "(" + orderChartType.applyWorn
                      ? orderChartType.applyWorn
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="3">
                  在库申请退回
                  {{
                    "(" + orderChartType.yesReturn
                      ? orderChartType.yesReturn
                      : 0 + ")"
                  }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="入库排序：" class="width100">
              <el-radio-group
                v-model="tableFrom.sort"
                type="button"
                @change="getList(1)"
              >
                <el-radio-button label="warehous_date DESC"
                  >降序
                </el-radio-button>
                <el-radio-button label="warehous_date ASC"
                  >升序
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="订单类型：" class="width100">
              <el-radio-group
                v-model="tableFrom.recovery_uid"
                type="button"
                @change="getList(1)"
              >
                <el-radio-button label="all">全部 </el-radio-button>
                <el-radio-button label="moren">普通订单 </el-radio-button>
                <el-radio-button label="7598">甄美订单 </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间选择：" class="width100">
              <el-radio-group
                v-model="tableFrom.date"
                type="button"
                class="mr20"
                size="small"
                @change="selectChange(tableFrom.date)"
              >
                <el-radio-button
                  v-for="(item, i) in fromList.fromTxt"
                  :label="item.val"
                  >{{ item.text }}
                </el-radio-button>
              </el-radio-group>
              <el-date-picker
                v-model="timeVal"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="daterange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px"
                @change="onchangeTime"
              />
            </el-form-item>
            <el-form-item label="入库时间：" class="width150">
              <el-date-picker
                v-model="warehousTimeVal"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                size="small"
                type="datetimerange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px"
                @change="onchangeWarehousTime"
              />
            </el-form-item>
            <el-form-item label="分类名称：" style="display: inline-block">
              <el-cascader
                v-model="tableFrom.category_id"
                class="selWidth"
                :options="recoveryCateList"
                :props="props"
                clearable
                @change="getList(1)"
              />
            </el-form-item>
            <el-form-item label="寄件类型：" style="display: inline-block">
              <el-select
                v-model="tableFrom.express_type"
                clearable
                placeholder="请选择"
                class="selWidth"
                @change="getList(1)"
              >
                <el-option label="自行寄件" value="1" />
                <el-option label="预约上门寄件" value="2" />
              </el-select>
            </el-form-item>
            <el-form-item
              label="物流单号："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="tableFrom.express_num"
                @keyup.enter.native="getList(1)"
                placeholder="请输入物流单号"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
            <el-form-item
              label="关键字："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="tableFrom.keywords"
                @keyup.enter.native="getList(1)"
                placeholder="请输入订单号/sku/收货人/联系方式"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
            <el-form-item
              label="用户信息："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="tableFrom.username"
                @keyup.enter.native="getList(1)"
                placeholder="请输入用户昵称/手机号"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
            <el-form-item
              label="批号："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="tableFrom.batch_number"
                @keyup.enter.native="getList(1)"
                placeholder="请输入批号"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <cards-data :card-lists="cardLists" />
        <div class="mb15">
          <el-button
            v-show="checkedIds.length != 0"
            size="mini"
            class="mr10"
            @click="batchGroup"
            >批量结算</el-button
          >
        </div>
        <el-alert
          v-if="checkedIds.length > 0 || allCheck"
          :title="
            allCheck
              ? `已选择  ${tableData.total}  项`
              : `已选择  ${checkedIds.length}  项`
          "
          type="info"
          show-icon
        />
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        height="500"
        size="small"
      >
        <!--        <el-table-column width="50">-->
        <!--          <template slot="header" slot-scope="scope">-->
        <!--            <el-popover placement="top-start" width="100" trigger="hover" class="tabPop">-->
        <!--              <div>-->
        <!--                <span class="spBlock onHand" :class="{'check': chkName === 'dan'}"-->
        <!--                      @click="onHandle('dan',scope.$index)">选中本页</span>-->
        <!--                <span class="spBlock onHand" :class="{'check': chkName === 'duo'}"-->
        <!--                      @click="onHandle('duo')">选中全部</span>-->
        <!--              </div>-->
        <!--              <el-checkbox slot="reference"-->
        <!--                           :value="(chkName === 'dan' && checkedPage.indexOf(tableFrom.page) > -1) || chkName === 'duo'"-->
        <!--                           @change="changeType"/>-->
        <!--            </el-popover>-->
        <!--          </template>-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-checkbox :disabled="scope.row.cancel_time"-->
        <!--                         :value="!scope.row.cancel_time && (checkedIds.indexOf(scope.row.recovery_order_id) > -1 || (chkName === 'duo' && noChecked.indexOf(scope.row.recovery_order_id) === -1))"-->
        <!--                         @change="(v)=>changeOne(v,scope.row)"/>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column label="ID" prop="recovery_order_id" min-width="60" />
        <el-table-column label="订单号" prop="order_sn" min-width="160" />
        <el-table-column label="手机号" prop="user.phone" min-width="100" />
        <el-table-column label="品类" min-width="200">
          <template slot-scope="scope">
            <!--            -->
            <el-tooltip
              :content="scope.row.category_name"
              placement="bottom"
              effect="light"
            >
              <div
                style="
                  height: 24px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  width: 160px;
                "
              >
                {{ scope.row.category_name }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="回收金额" prop="recovery_price" min-width="100">
          <template slot-scope="scope">
            <div style="position: relative; height: 50px">
              {{ scope.row.recovery_price }}
              <span
                style="
                  position: absolute;
                  left: 30%;
                  bottom: 0;
                  transform: translate(-50%, 20%);
                  white-space: nowrap;
                  color: red;
                "
              >
                {{
                  scope.row.status == 0
                    ? "报单预估金额"
                    : scope.row.status == 1
                    ? "入库预估金额"
                    : scope.row.status == 2
                    ? "实际出库金额"
                    : ""
                }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="回收数量" prop="recovery_num" min-width="80">
          <template slot-scope="scope">
            <div style="position: relative; height: 50px">
              {{ scope.row.recovery_num }}
              <span
                style="
                  position: absolute;
                  left: 30%;
                  bottom: 0;
                  transform: translate(-50%, 20%);
                  white-space: nowrap;
                  color: red;
                "
              >
                {{
                  scope.row.status == 0
                    ? "报单数量"
                    : scope.row.status == 1
                    ? "入库数量"
                    : scope.row.status == 2
                    ? "出库数量"
                    : ""
                }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="已出库金额"
          prop="already_recovery_price"
          min-width="100"
        />
        <el-table-column
          label="已出库数量"
          prop="already_recovery_num"
          min-width="80"
        />
        <el-table-column label="是否寄存" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.product_deposit == 2 ? "有" : "无" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status_text" min-width="160" />
        <el-table-column label="商品状态" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.is_worn == 1 ? "有异常" : "正常" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="异常申请退回" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.apply_return == 1 ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="入库时间" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.warehous_date ? scope.row.warehous_date : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.create_time ? scope.row.create_time : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="180" fixed="right">
          <template slot-scope="scope">
            <div style="display: flex; flex-wrap: wrap">
              <el-button
                type="text"
                size="small"
                @click="onDetail(scope.row.recovery_order_id)"
                >详情</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="
                  (scope.row.status == 0 || scope.row.status == 1) &&
                  scope.row.warehous_status > 0
                "
                @click="onEdit(scope.row.recovery_order_id)"
                >出库结算
              </el-button>
              <el-button
                type="text"
                size="small"
                v-if="
                  scope.row.express_type == 2 && scope.row.order_express
                    ? scope.row.order_express.express_status == 0
                    : false
                "
                @click="onCancelExpress(scope.row.recovery_order_id, scope.row)"
                >取消寄件
              </el-button>
              <el-button
                type="text"
                size="small"
                v-if="
                  (scope.row.status == 0 || scope.row.status == 1) &&
                  scope.row.warehous_status >= 1 &&
                  scope.row.apply_return < 2
                "
                @click="onWornHandle(scope.row.recovery_order_id)"
                >异常处理
              </el-button>
              <el-button
                type="text"
                size="small"
                v-if="scope.row.return_count > 0"
                @click="onReturnHandle(scope.row.recovery_order_id)"
                >在库退回处理
              </el-button>
              <el-button
                type="text"
                size="small"
                v-if="
                  (scope.row.status == 0 || scope.row.status == 1) &&
                  scope.row.warehous_status >= 1 &&
                  scope.row.apply_return == 2 &&
                  scope.row.worn_cancel_handle == 1
                "
                @click="handleWornHandle(scope.row.recovery_order_id)"
                >取消异常订单
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="handleDelete(scope.row.recovery_order_id, scope.$index)"
                >删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
    <el-dialog title="详情" width="300px" top="300px" :visible.sync="show">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
        "
      >
        <el-radio v-model="type" label="1">增加</el-radio>
        <el-radio v-model="type" label="0">减少</el-radio>
      </div>
      <div style="display: flex; justify-content: center; width: 100%">
        <el-input-number
          v-model="num"
          @change="handleChange"
          :min="0"
          label="描述文字"
          style="margin-top: 40px"
        ></el-input-number>
      </div>

      <div
        style="
          display: flex;
          align-items: center;
          margin-top: 40px;
          justify-content: center;
        "
      >
        <el-button type="danger" @click="show = false"> 取消</el-button>
        <el-button
          type="primary"
          style="margin-left: 20px"
          @click="orderDetailUpdateFn"
          >修改</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      v-if="dialogVisible"
      title="详情"
      :visible.sync="dialogVisible"
      width="1300px"
      top="0"
    >
      <div v-loading="loading" class="divBox boxDetial">
        <el-card class="box-card">
          <el-form ref="formData" label-width="130px" class="demo-ruleForm">
            <el-row :gutter="24">
              <el-col :span="4">
                <el-form-item label-width="80px" label="订单ID：">
                  <div>{{ formData.recovery_order_id }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="100px" label="用户手机号：">
                  <div>{{ formData.user.phone }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label-width="100px" label="订单号：">
                  <div>{{ formData.order_sn }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="80px" label="状态：">
                  <div>{{ formData.status_text }}</div>
                </el-form-item>
              </el-col>
              <!-- 报单信息 -->
              <div class="decla_row">
                <div class="decla_title" @click="show = true">报单信息</div>
                <div
                  v-for="(item, index) in formData.product_list"
                  style="display: inline-block"
                >
                  <el-col :span="24">
                    <el-form-item
                      :label="(item.cate_name ? item.cate_name : '其他') + '：'"
                    ></el-form-item>
                  </el-col>
                  <div v-for="(it, inf) in item.sku_list">
                    <el-col :span="24">
                      <el-form-item label="">
                        <span>sku : {{ it.sku }}</span> &nbsp;&nbsp;&nbsp;&nbsp;
                        <span>数量 : {{ it.num }}</span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span>价格 : {{ it.price }}</span>

                        <!--                        <div v-if="formData.status == 2">结算备注 : {{ it.sett_remark }}</div>-->
                      </el-form-item>
                    </el-col>
                  </div>
                </div>
                <div style="display: flex; flex-direction: column">
                  <div style="display: inline-block">
                    <el-col>
                      <el-form-item label="报单总数量：">
                        <div class="blodClass">{{ recoveryNum(formData) }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col>
                      <el-form-item label="报单预估金额：">
                        <div>{{ recovery_price }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col :span="12">
                      <el-form-item label="联系人：">
                        <div>{{ formData.express_phone }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col :span="24">
                      <el-form-item label="补充图片：">
                        <div
                          v-for="(item, index) in formData.express_image"
                          style="display: inline-block; margin: 0 10px 10px 0"
                        >
                          <el-image
                            style="width: 80px; height: 80px"
                            :src="item || ''"
                            :preview-src-list="[item ? item : '']"
                          />
                        </div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col :span="24">
                      <el-form-item label="平台地址：">
                        <div>{{ formData.platform_address }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div class="display: inline-block">
                    <el-col :span="12">
                      <el-form-item label="平台收件人：">
                        <div>{{ formData.platform_name }}</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="平台联系电话：">
                        <div>{{ formData.platform_phone }}</div>
                      </el-form-item>
                    </el-col>
                  </div>

                  <div style="display: inline-block">
                    <el-col :span="24">
                      <el-form-item label="用户地址：">
                        <div>{{ formData.user_address }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col :span="12">
                      <el-form-item label="用户收件人：">
                        <div>{{ formData.user_name }}</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="用户联系电话：">
                        <div>{{ formData.user_phone }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col :span="24">
                      <el-form-item label="寄件类型：">
                        <span>{{
                          formData.express_type == 1 ? "自行寄件" : "预约上门"
                        }}</span>
                      </el-form-item>
                    </el-col>
                  </div>
                  <el-col :span="24">
                    <el-form-item
                      label="寄件地址："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.express_address }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="寄件人："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.express_name }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="寄件电话："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.express_phone }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="商品重量："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.express_weight }}KG</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="物流创建时间："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.create_time }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="取件时间："
                      v-if="formData.express_type == 2"
                    >
                      <span
                        >{{ formData.order_express.express_day_type }}
                        {{ formData.order_express.express_pickup_start }}-{{
                          formData.order_express.express_pickup_end
                        }}</span
                      >
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="物流公司："
                      v-if="formData.express_type == 2"
                    >
                      <span
                        >{{ formData.order_express.product_express_company }}
                        {{ formData.order_express.express_num }}</span
                      >
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="邮费："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.express_price }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="物流状态："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{
                        formData.order_express.express_status == 0
                          ? "提交订单，待取件"
                          : formData.order_express.express_status == 1
                          ? "已取件"
                          : formData.order_express.express_status == 2
                          ? "已支付"
                          : "已取消"
                      }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="物流支付状态："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{
                        formData.order_express.express_pay == 1
                          ? "已支付"
                          : "未支付"
                      }}</span>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="创建时间：">
                      <div>{{ formData.create_time }}</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="完成时间："
                      v-if="
                        formData.status == 1 ||
                        formData.status == -2 ||
                        formData.status == -1
                      "
                    >
                      <div>{{ formData.recovery_time }}</div>
                    </el-form-item>
                  </el-col>
                </div>
              </div>
              <!--              <el-col :span="12">-->
              <!--                <el-form-item label="物流单号：">-->
              <!--                  <div>{{formData.express_num}}</div>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <!--              <el-col :span="12">-->
              <!--                <el-form-item label="物流公司：">-->
              <!--                  <div>{{formData.express_company}}</div>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <!-- 物流信息 -->
              <div
                style="
                  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                  margin-top: 20px;
                  padding: 20px 0;
                  width: 100%;
                "
              >
                <div
                  v-for="(item, index) in formData.express_list"
                  style="display: inline-block"
                >
                  <el-col :span="24">
                    <el-form-item :label="'物流信息' + (index + 1) + '：'">
                      单号：{{ item.express_num }} - {{ item.express_company }}
                      {{
                        item.express_status == 1
                          ? "已入库"
                          : item.express_status == 2
                          ? "已结算"
                          : "未入库"
                      }}
                      - 入库时间 : {{ item.express_time }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="">
                      <div class="blodClass" v-if="item.express_status >= 1">
                        入库备注 : {{ item.express_remark }}
                      </div>
                      <div
                        v-for="(it, ind) in item.express_image"
                        v-if="item.express_status >= 1"
                        style="display: inline-block"
                      >
                        <el-image
                          style="width: 120px; height: 120px"
                          :src="it || ''"
                          :preview-src-list="[it ? it : '']"
                        />
                      </div>
                      <div
                        v-for="(vi, vind) in item.express_video"
                        v-if="item.express_video"
                        style="display: inline-block"
                      >
                        <video
                          style="width: 120px; height: 120px"
                          :src="vi"
                          controls="controls"
                        >
                          您的浏览器不支持 video 标签。
                        </video>
                      </div>
                      <div
                        v-for="(p, vind) in item.product_list"
                        v-if="item.express_status >= 1"
                        style="display: inline-block; width: 100%"
                      >
                        <span style="font-weight: bold"
                          >商品名 :
                          {{ p.cate_name ? p.cate_name : "其他" }}</span
                        >
                        <table class="sku-tb">
                          <tr style="border: 1px solid black">
                            <th>sku</th>
                            <th>入库数</th>
                            <th>入库批号</th>
                            <th>在库</th>
                            <th>出库</th>
                            <th width="50px">已出库单价</th>
                            <th width="50px">已出库总额</th>
                            <th width="50px">寄存数量</th>
                            <th width="50px">
                              <span class="blodClass">退回数量</span>
                            </th>
                            <th width="50px">
                              <span class="blodClass" style="font-size: 12px"
                                >入库异常总数量</span
                              >
                            </th>
                            <th class="blodClass" width="50px">假货异常数量</th>
                            <th width="50px">
                              <span class="blodClass" style="font-size: 12px"
                                >处理异常数量</span
                              >
                            </th>
                            <th width="80px">
                              <span class="blodClass">异常备注</span>
                            </th>
                            <th width="50px">异常图片</th>
                            <th><span class="blodClass">结算备注</span></th>
                          </tr>
                          <tr v-for="(sku, index) in p.sku_list">
                            <td>
                              <el-tooltip
                                :content="sku.sku"
                                placement="bottom"
                                effect="light"
                              >
                                <div class="sku-name">{{ sku.sku }}</div>
                              </el-tooltip>
                            </td>
                            <td>
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  width: 100%;
                                  justify-content: center;
                                "
                              >
                                {{ sku.num
                                }}<img
                                  v-if="sku.warehous_count"
                                  src="../../../assets/images/editIcon.png"
                                  style="
                                    width: 15px;
                                    height: 15px;
                                    margin-top: -5px;
                                    margin-left: 10px;
                                  "
                                  alt=""
                                  @click="editNumFn(item, sku, 1)"
                                />
                              </div>
                            </td>
                            <td>
                              <div v-for="(item, index) in sku.batch_list">
                                {{ item.batch_number }}
                                <span class="batch_num"
                                  >x{{ item.batch_num }}</span
                                >
                              </div>
                            </td>
                            <td>{{ sku.warehous_count }}</td>
                            <td>{{ sku.outbound_count }}</td>
                            <td>{{ parseInt(sku.outbound_price) }}</td>
                            <td>{{ sku.outbound_price_all }}</td>
                            <td>
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  width: 100%;
                                  justify-content: center;
                                "
                              >
                                {{
                                  sku.sku_product_deposit_num
                                    ? sku.sku_product_deposit_num
                                    : "-"
                                }}
                              </div>
                            </td>
                            <td class="blodClass">
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  width: 100%;
                                  justify-content: center;
                                "
                              >
                                {{
                                  sku.sku_product_return_num
                                    ? sku.sku_product_return_num
                                    : "-"
                                }}
                              </div>
                            </td>
                            <td>
                              <span
                                v-if="sku.worn_num"
                                class="blodClass"
                                style=""
                                >{{ sku.worn_num }}</span
                              >
                              <span v-else>无</span>
                            </td>
                            <td class="blodClass">
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  width: 100%;
                                  justify-content: center;
                                "
                              >
                                <span
                                  v-if="sku.fail_count"
                                  class="blodClass"
                                  style=""
                                  >{{ sku.fail_count }}</span
                                >

                                <span v-else>无</span>
                                <img
                                  v-if="sku.warehous_count"
                                  src="../../../assets/images/editIcon.png"
                                  style="
                                    width: 15px;
                                    height: 15px;
                                    margin-top: -5px;
                                    margin-left: 10px;
                                  "
                                  @click="editNumFn(item, sku, 3)"
                                />
                              </div>
                            </td>
                            <td>
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  width: 100%;
                                  justify-content: center;
                                "
                              >
                                <span
                                  v-if="sku.worn_return"
                                  class="blodClass"
                                  style=""
                                  >{{ sku.worn_return }}</span
                                >
                                <span v-else>无</span>
                              </div>
                            </td>
                            <td>
                              <template v-if="sku.worn_num">
                                <el-tooltip
                                  :content="sku.remark"
                                  placement="bottom"
                                  effect="light"
                                >
                                  <div class="sku-name blodClass">
                                    {{ sku.remark }}
                                  </div>
                                </el-tooltip>
                              </template>
                              <template v-else>-</template>
                            </td>
                            <td>
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                "
                                v-if="sku.image.length"
                              >
                                <el-image
                                  style="width: 30px; height: 30px"
                                  :src="skui || ''"
                                  :preview-src-list="[skui ? skui : '']"
                                  v-for="skui in sku.image"
                                />
                              </div>
                              <span v-else>-</span>
                            </td>
                            <td class="blodClass">
                              {{ sku.sett_remark ? sku.sett_remark : "-" }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </el-form-item>
                  </el-col>
                </div>
              </div>
              <div
                style="width: 100%; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)"
                v-if="formData.order_return_list.length > 0"
              >
                <div style="display: inline-block; width: 100%">
                  <el-col :span="24">
                    <el-form-item label="退回详情：">
                      <!--                      <div v-if="formData.apply_return==1">{{formData.apply_time}}→<span style="color: red">申请退回</span></div>-->
                      <table class="sku-tb">
                        <tr style="border: 1px solid black">
                          <th>sku</th>
                          <th>申请时间</th>
                          <th>退回数量</th>
                          <th>快递单号</th>
                          <th>快递员姓名</th>
                          <th>快递员电话</th>
                          <th>物流状态</th>
                          <th>状态</th>
                        </tr>
                        <tr v-for="(sku, index) in formData.order_return_list">
                          <td>
                            <div class="sku-name">
                              {{ sku.cate_name + sku.sku }}
                            </div>
                          </td>
                          <td>{{ sku.create_time }}</td>
                          <td>{{ sku.num }}</td>
                          <td>
                            {{ sku.express_num }}
                          </td>
                          <td>
                            {{ sku.order_return_express?sku.order_return_express.courierName:'' }}
                          </td>
                          <td>
                            {{ sku.order_return_express?sku.order_return_express.courierMobile:'' }}
                          </td>
                          <td>
                            {{ wornStatusFn(sku.order_return_express?sku.order_return_express.express_platform_status:-1)}}
                          </td>
                          <td>
                            {{ sku.apply_return == 1 ? "申请退回" : "已退回" }}
                          </td>
                        </tr>
                      </table>
                    </el-form-item>
                  </el-col>
                </div>
              </div>

              <div
                style="width: 100%; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)"
                v-if="formData.apply_return"
              >
                <div style="display: inline-block; width: 100%">
                  <el-col :span="24">
                    <el-form-item label="异常处理：">
                      <div v-if="formData.apply_return == 1">
                        {{ formData.apply_time }}→<span style="color: red"
                          >申请退回</span
                        >
                      </div>
                      <div v-if="formData.apply_return == 2">
                        {{ formData.wore_handle_time }}
                        <span style="margin-left: 20px">物流公司：</span>
                        {{ formData.wore_handle_express_company }}
                        <span style="margin-left: 20px">快递单号：</span
                        >{{ formData.wore_handle_express_num }}
                        <span style="margin-left: 20px"> 物流状态：</span
                        >{{
                          wornStatusFn(
                            formData.order_worn_express_cust
                              ? formData.order_worn_express_cust
                                  .express_platform_status
                              : ""
                          )
                        }}
                        <span style="margin-left: 20px"> 快递员电话：</span
                        >{{
                          formData.order_worn_express_cust
                            ? formData.order_worn_express_cust.courierMobile
                            : ""
                        }}
                      </div>

                      <div
                        v-if="formData.apply_return == 1"
                        v-for="(re, ind) in formData.apply_content"
                      >
                        <span style="font-weight: bold"
                          >{{ re.cate_name ? re.cate_name : "其他" }}:</span
                        >
                        <div
                          v-for="(re2, ind2) in re.sku_list"
                          style="padding-left: 50px"
                        >
                          {{ re2.sku }}&nbsp;&nbsp;x&nbsp;<span
                            style="font-size: 16px; color: red"
                            >{{ re2.num }}
                          </span>
                        </div>
                      </div>
                      <div
                        v-if="formData.apply_return == 2"
                        v-for="(re, ind) in formData.worn_handle_content"
                      >
                        <span style="font-weight: bold"
                          >{{ re.cate_name }}:</span
                        >
                        <div
                          v-for="(re2, ind2) in re.sku_list"
                          style="padding-left: 50px"
                        >
                          {{ re2.sku }}&nbsp;<span
                            style="font-size: 16px; color: red"
                            >&nbsp;x&nbsp;{{ re2.num }}</span
                          >
                        </div>
                      </div>
                      <div class="blodClass">
                        异常备注：{{ formData.worn_handle_remark }}
                      </div>
                    </el-form-item>
                  </el-col>
                </div>
              </div>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-dialog>
    <!-- 出库结算 -->
    <el-dialog
      v-if="dialogVisibleStatus"
      title="出库结算"
      :visible.sync="dialogVisibleStatus"
      fullscreen
      top="0"
      :before-close="handleClose"
    >
      <div
        style="display: flex; justify-content: center"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <div
          class="divBox boxDetial"
          style="flex: 1; height: 100vh; overflow-y: auto"
        >
          <el-card class="box-card">
            <el-form ref="formData" label-width="130px" class="demo-ruleForm">
              <el-row :gutter="24">
                <el-col :span="4">
                  <el-form-item label-width="70px" label="订单ID：">
                    <div>{{ formData.recovery_order_id }}</div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="100px" label="用户手机号：">
                    <div>{{ formData.user.phone }}</div>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="100px" label="订单号：">
                    <div>{{ formData.order_sn }}</div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="80px" label="状态：">
                    <div>{{ formData.status_text }}</div>
                  </el-form-item>
                </el-col>
                <!-- 报单信息 -->
                <div class="decla_row">
                  <div class="decla_title">报单信息</div>
                  <div
                    v-for="(item, index) in formData.product_list"
                    style="display: inline-block"
                  >
                    <el-col :span="24">
                      <el-form-item
                        :label="
                          (item.cate_name ? item.cate_name : '其他') + '：'
                        "
                      ></el-form-item>
                    </el-col>
                    <div v-for="(it, inf) in item.sku_list">
                      <el-col :span="24">
                        <el-form-item label="">
                          <span>sku : {{ it.sku }}</span>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <span>数量 : {{ it.num }}</span>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <span>价格 : {{ it.price }}</span>
                          <div v-if="it.is_worn == 1" style="color: red">
                            状态 : {{ it.is_worn == 1 ? "破损" : "未破损" }}
                          </div>
                          <div v-if="it.is_worn == 1">
                            入库备注 : {{ it.remark }}
                          </div>
                          <div
                            v-if="it.is_worn == 1"
                            v-for="(im, imind) in it.image"
                            style="display: inline-block"
                          >
                            <el-image
                              style="width: 80px; height: 80px"
                              :src="im || ''"
                              :preview-src-list="[im ? im : '']"
                            />
                          </div>
                          <div v-if="formData.status == 2">
                            结算备注 : {{ it.sett_remark }}
                          </div>
                        </el-form-item>
                      </el-col>
                    </div>
                  </div>
                  <div style="display: flex; flex-direction: column">
                    <div style="display: inline-block">
                      <el-col>
                        <el-form-item label="报单总数量：">
                          <div class="blodClass">
                            {{ recoveryNum(formData) }}
                          </div>
                        </el-form-item>
                      </el-col>
                    </div>
                    <div style="display: inline-block">
                      <el-col>
                        <el-form-item label="预估金额：">
                          <div>{{ formData.recovery_price }}</div>
                        </el-form-item>
                      </el-col>
                    </div>
                    <div style="display: inline-block">
                      <el-col :span="12">
                        <el-form-item label="联系人：">
                          <div>{{ formData.express_phone }}</div>
                        </el-form-item>
                      </el-col>
                    </div>
                    <div style="display: inline-block">
                      <el-col :span="24">
                        <el-form-item label="补充图片：">
                          <div
                            v-for="(item, index) in formData.express_image"
                            style="display: inline-block; margin: 0 10px 10px 0"
                          >
                            <el-image
                              style="width: 80px; height: 80px"
                              :src="item || ''"
                              :preview-src-list="[item ? item : '']"
                            />
                          </div>
                        </el-form-item>
                      </el-col>
                    </div>
                    <div style="display: inline-block">
                      <el-col :span="24">
                        <el-form-item label="平台地址：">
                          <div>{{ formData.platform_address }}</div>
                        </el-form-item>
                      </el-col>
                    </div>
                    <div class="display: inline-block">
                      <el-col :span="12">
                        <el-form-item label="平台收件人：">
                          <div>{{ formData.platform_name }}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="平台联系电话：">
                          <div>{{ formData.platform_phone }}</div>
                        </el-form-item>
                      </el-col>
                    </div>

                    <div style="display: inline-block">
                      <el-col :span="24">
                        <el-form-item label="用户地址：">
                          <div>{{ formData.user_address }}</div>
                        </el-form-item>
                      </el-col>
                    </div>
                    <div style="display: inline-block">
                      <el-col :span="12">
                        <el-form-item label="用户收件人：">
                          <div>{{ formData.user_name }}</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="用户联系电话：">
                          <div>{{ formData.user_phone }}</div>
                        </el-form-item>
                      </el-col>
                    </div>
                    <div style="display: inline-block">
                      <el-col :span="24">
                        <el-form-item label="寄件类型：">
                          <span>{{
                            formData.express_type == 1 ? "自行寄件" : "预约上门"
                          }}</span>
                        </el-form-item>
                      </el-col>
                    </div>
                    <el-col :span="24">
                      <el-form-item
                        label="寄件地址："
                        v-if="formData.express_type == 2"
                      >
                        <span>{{
                          formData.order_express.express_address
                        }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="寄件人："
                        v-if="formData.express_type == 2"
                      >
                        <span>{{ formData.order_express.express_name }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="寄件电话："
                        v-if="formData.express_type == 2"
                      >
                        <span>{{ formData.order_express.express_phone }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="商品重量："
                        v-if="formData.express_type == 2"
                      >
                        <span
                          >{{ formData.order_express.express_weight }}KG</span
                        >
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="物流创建时间："
                        v-if="formData.express_type == 2"
                      >
                        <span>{{ formData.order_express.create_time }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="取件时间："
                        v-if="formData.express_type == 2"
                      >
                        <span
                          >{{ formData.order_express.express_day_type }}
                          {{ formData.order_express.express_pickup_start }}-{{
                            formData.order_express.express_pickup_end
                          }}</span
                        >
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="物流公司："
                        v-if="formData.express_type == 2"
                      >
                        <span
                          >{{ formData.order_express.product_express_company }}
                          {{ formData.order_express.express_num }}</span
                        >
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="邮费："
                        v-if="formData.express_type == 2"
                      >
                        <span>{{ formData.order_express.express_price }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="物流状态："
                        v-if="formData.express_type == 2"
                      >
                        <span>{{
                          formData.order_express.express_status == 0
                            ? "提交订单，待取件"
                            : formData.order_express.express_status == 1
                            ? "已取件"
                            : formData.order_express.express_status == 2
                            ? "已支付"
                            : "已取消"
                        }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="物流支付状态："
                        v-if="formData.express_type == 2"
                      >
                        <span>{{
                          formData.order_express.express_pay == 1
                            ? "已支付"
                            : "未支付"
                        }}</span>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="创建时间：">
                        <div>{{ formData.create_time }}</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        label="完成时间："
                        v-if="
                          formData.status == 1 ||
                          formData.status == -2 ||
                          formData.status == -1
                        "
                      >
                        <div>{{ formData.recovery_time }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                </div>
                <!--              <el-col :span="12">-->
                <!--                <el-form-item label="物流单号：">-->
                <!--                  <div>{{formData.express_num}}</div>-->
                <!--                </el-form-item>-->
                <!--              </el-col>-->
                <!--              <el-col :span="12">-->
                <!--                <el-form-item label="物流公司：">-->
                <!--                  <div>{{formData.express_company}}</div>-->
                <!--                </el-form-item>-->
                <!--              </el-col>-->
                <!-- 物流信息 -->
                <div
                  style="
                    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                    margin-top: 20px;
                    padding: 20px 0;
                    width: 100%;
                    overflow-x: scroll;
                  "
                >
                  <div
                    v-for="(item, index) in formData.express_list"
                    style="display: inline-block"
                  >
                    <el-col :span="24">
                      <el-form-item :label="'物流信息' + (index + 1) + '：'">
                        单号：{{ item.express_num }} -
                        {{ item.express_company }}
                        {{
                          item.express_status == 1
                            ? "已入库"
                            : item.express_status == 2
                            ? "已结算"
                            : "未入库"
                        }}
                        - 入库时间 : {{ item.express_time }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="" v-if="item.express_status >= 1">
                        <div class="blodClass">
                          入库备注 : {{ item.express_remark }}
                        </div>
                        <div
                          v-for="(it, ind) in item.express_image"
                          style="display: inline-block"
                        >
                          <el-image
                            style="width: 120px; height: 120px"
                            :src="it || ''"
                            :preview-src-list="[it ? it : '']"
                          />
                        </div>
                        <div
                          v-for="(vi, vind) in item.express_video"
                          style="display: inline-block"
                        >
                          <video
                            style="width: 120px; height: 120px"
                            :src="vi"
                            controls="controls"
                          >
                            您的浏览器不支持 video 标签。
                          </video>
                        </div>
                        <div
                          v-for="(p, vind) in item.product_list"
                          style="display: inline-block"
                        >
                          <span style="font-weight: bold"
                            >商品名 :
                            {{ p.cate_name ? p.cate_name : "其他" }}</span
                          >
                          <table class="sku-tb">
                            <tr style="border: 1px solid black">
                              <th>sku</th>
                              <th>入库数</th>
                              <th>入库批号</th>
                              <th>在库</th>
                              <th>出库</th>
                              <th width="50px">已出库单价</th>
                              <th width="50px">已出库总额</th>
                              <th>寄存数量</th>
                              <th><span class="blodClass">退回数量</span></th>
                              <th width="50px">
                                <span class="blodClass" style="font-size: 12px"
                                  >入库异常总数量</span
                                >
                              </th>
                              <th class="blodClass" width="50px">
                                假货异常数量
                              </th>
                              <th>
                                <span class="blodClass">处理异常数量</span>
                              </th>
                              <th><span class="blodClass">异常备注</span></th>
                              <th>异常图片</th>
                              <th><span class="blodClass">结算备注</span></th>
                            </tr>
                            <tr v-for="(sku, index) in p.sku_list">
                              <td>
                                <el-tooltip
                                  :content="sku.sku"
                                  placement="bottom"
                                  effect="light"
                                >
                                  <div class="sku-name">{{ sku.sku }}</div>
                                </el-tooltip>
                              </td>
                              <td>{{ sku.num }}</td>
                              <td>
                                <div v-for="(item, index) in sku.batch_list">
                                  {{ item.batch_number }}
                                  <span class="batch_num"
                                    >x{{ item.batch_num }}</span
                                  >
                                </div>
                              </td>
                              <td>{{ sku.warehous_count }}</td>
                              <td>{{ sku.outbound_count }}</td>
                              <td>{{ parseInt(sku.outbound_price) }}</td>
                              <td>{{ sku.outbound_price_all }}</td>
                              <td>
                                {{
                                  sku.sku_product_deposit_num
                                    ? sku.sku_product_deposit_num
                                    : "-"
                                }}
                              </td>
                              <td class="blodClass">
                                {{
                                  sku.sku_product_return_num
                                    ? sku.sku_product_return_num
                                    : "-"
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="sku.worn_num"
                                  class="blodClass"
                                  style=""
                                  >{{ sku.worn_num }}</span
                                >
                                <span v-else>无</span>
                              </td>
                              <td class="blodClass">
                                <span
                                  v-if="sku.fail_count"
                                  class="blodClass"
                                  style=""
                                  >{{ sku.fail_count }}</span
                                >
                                <span v-else>无</span>
                              </td>
                              <td class="blodClass">
                                {{ sku.worn_return ? sku.worn_return : "-" }}
                              </td>
                              <td>
                                <template v-if="sku.worn_num">
                                  <el-tooltip
                                    :content="sku.remark"
                                    placement="bottom"
                                    effect="light"
                                  >
                                    <div class="sku-name blodClass">
                                      {{ sku.remark }}
                                    </div>
                                  </el-tooltip>
                                </template>
                                <template v-else>-</template>
                              </td>
                              <td>
                                <div
                                  style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                  "
                                  v-if="sku.image.length"
                                >
                                  <el-image
                                    style="width: 30px; height: 30px"
                                    :src="skui || ''"
                                    :preview-src-list="[skui ? skui : '']"
                                    v-for="skui in sku.image"
                                  />
                                </div>
                                <span v-else>-</span>
                              </td>
                              <td class="blodClass">
                                {{ sku.sett_remark ? sku.sett_remark : "-" }}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </el-form-item>
                    </el-col>
                  </div>
                </div>
                <div
                  style="
                    width: 100%;
                    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                  "
                  v-if="formData.order_return_list.length > 0"
                >
                  <div style="display: inline-block; width: 100%">
                    <el-col :span="24">
                      <el-form-item label="退回详情：">
                        <!--                      <div v-if="formData.apply_return==1">{{formData.apply_time}}→<span style="color: red">申请退回</span></div>-->
                        <table class="sku-tb">
                          <tr style="border: 1px solid black">
                            <th>sku</th>
                            <th>申请时间</th>
                            <th>退回数量</th>
                            <th>快递单号</th>
                            <th>状态</th>
                          </tr>
                          <tr
                            v-for="(sku, index) in formData.order_return_list"
                          >
                            <td>
                              <div class="sku-name">
                                {{ sku.cate_name + sku.sku }}
                              </div>
                            </td>
                            <td>{{ sku.create_time }}</td>
                            <td>{{ sku.num }}</td>
                            <td>
                              {{ sku.express_num }}
                            </td>
                            <td>
                              {{
                                sku.apply_return == 1 ? "申请退回" : "已退回"
                              }}
                            </td>
                          </tr>
                        </table>
                      </el-form-item>
                    </el-col>
                  </div>
                </div>

                <div
                  style="
                    width: 100%;
                    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                  "
                  v-if="formData.apply_return"
                >
                  <div style="display: inline-block; width: 100%">
                    <el-col :span="24">
                      <el-form-item label="异常处理：">
                        <div v-if="formData.apply_return == 1">
                          {{ formData.apply_time }}→<span style="color: red"
                            >申请退回</span
                          >
                        </div>
                        <div v-if="formData.apply_return == 2">
                          {{ formData.wore_handle_time }}
                          <span style="margin-left: 20px">物流公司：</span>
                          {{ formData.wore_handle_express_company }}
                          <span style="margin-left: 20px">快递单号：</span
                          >{{ formData.wore_handle_express_num }}
                          <span style="margin-left: 20px"> 物流状态：</span
                          >{{
                            wornStatusFn(
                              formData.express_type == 2
                                ? formData.order_worn_express
                                    .express_platform_status
                                : ""
                            )
                          }}
                          <span style="margin-left: 20px"> 快递员电话：</span
                          >{{
                            formData.express_type == 2
                              ? formData.order_worn_express.courierMobile
                              : ""
                          }}
                        </div>

                        <div
                          v-if="formData.apply_return == 1"
                          v-for="(re, ind) in formData.apply_content"
                        >
                          <span style="font-weight: bold"
                            >{{ re.cate_name ? re.cate_name : "其他" }}:</span
                          >
                          <div
                            v-for="(re2, ind2) in re.sku_list"
                            style="padding-left: 50px"
                          >
                            {{ re2.sku }}&nbsp;&nbsp;x&nbsp;<span
                              style="font-size: 16px; color: red"
                              >{{ re2.num }}
                            </span>
                          </div>
                        </div>
                        <div
                          v-if="formData.apply_return == 2"
                          v-for="(re, ind) in formData.worn_handle_content"
                        >
                          <span style="font-weight: bold"
                            >{{ re.cate_name }}:</span
                          >
                          <div
                            v-for="(re2, ind2) in re.sku_list"
                            style="padding-left: 50px"
                          >
                            {{ re2.sku }}&nbsp;<span
                              style="font-size: 16px; color: red"
                              >&nbsp;x&nbsp;{{ re2.num }}</span
                            >
                          </div>
                        </div>
                        <div class="blodClass">
                          异常备注：{{ formData.worn_handle_remark }}
                        </div>
                      </el-form-item>
                    </el-col>
                  </div>
                </div>
              </el-row>
            </el-form>
          </el-card>
        </div>
        <div
          v-loading="loading"
          class="divBox"
          style="flex: 0.6; height: 100vh; overflow-y: auto"
        >
          <el-card class="box-card">
            <el-form ref="formData" label-width="120px" class="demo-ruleForm">
              <el-row :gutter="24">
                <div style="display: inline-block">
                  <el-col :span="24">
                    <el-form-item label="状态：" label-width="60px">
                      <el-select
                        v-model="status"
                        clearable
                        placeholder="请选择状态"
                      >
                        <el-option
                          v-for="(item, index) in statusList"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </div>
                <el-col :span="24">
                  <el-form-item label="用户地址：" v-if="status == -2">
                    <el-input
                      v-model="formStatusData.user_address"
                      type="text"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="联系人：" v-if="status == -2">
                    <el-input v-model="formStatusData.user_name" type="text" />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="联系电话：" v-if="status == -2">
                    <el-input v-model="formStatusData.user_phone" type="text" />
                  </el-form-item>
                </el-col>
                <div
                  v-if="status == 2 && old_flag != 2"
                  v-for="(itemp, indexp) in formStatusData.product_list"
                >
                  <el-col :span="24">
                    <div style="color: red">{{ itemp.category_name }}</div>
                  </el-col>
                  <div v-for="(ito, indexito) in itemp.sku_list">
                    <el-col :span="3">
                      <span>{{ ito.sku }}</span>
                    </el-col>
                    <el-col :span="7">
                      <el-form-item label="单价：">
                        <el-input
                          v-model="ito.one_price"
                          type="number"
                          @change="onchangePriceRecovery(indexp, indexito)"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="数量：">
                        <el-input
                          v-model="ito.num"
                          min="0"
                          type="number"
                          @change="onchangeNumRecovery(indexp, indexito)"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="7">
                      <el-form-item label="总价：">
                        <el-input
                          v-model="ito.price"
                          type="number"
                          @change="onchangeRecovery"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="50">
                      <el-form-item label="备注：">
                        <el-input v-model="ito.sett_remark" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="">
                        <el-checkbox
                          v-model="ito.sett_check"
                          :true-label="1"
                          :false-label="0"
                        />
                      </el-form-item>
                    </el-col>
                  </div>
                </div>
                <div
                  v-if="status == 2 && old_flag == 2"
                  v-for="(iteme, indexe) in formStatusData.express_list"
                >
                  <div style="display: inline-block">
                    <el-col :span="50">
                      <div style="color: red">
                        <span>快递单号:</span> {{ iteme.express_num }}
                      </div>
                    </el-col>
                    <el-col :span="50">
                      <div style="color: red">
                        <span>是否到付:</span>
                        {{ iteme.express_pay_status == 1 ? "是" : "否" }}
                      </div>
                    </el-col>
                    <el-col :span="50">
                      <div style="color: red">
                        <span>备注:</span> {{ iteme.express_remark }}
                      </div>
                    </el-col>
                  </div>
                  <!--                  <el-col :span="12">-->
                  <!--                    <div style="color:red"><span>物流公司:</span> {{ iteme.express_company }}</div>-->
                  <!--                  </el-col>-->
                  <div
                    v-if="status == 2 && old_flag == 2"
                    v-for="(itemp, indexp) in iteme.product_list"
                    style="
                      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                      padding-top: 20px;
                      margin: 10px 0;
                    "
                  >
                    <el-col :span="24">
                      <div style="color: red; margin-bottom: 10px">
                        {{ itemp.cate_name }}
                      </div>
                    </el-col>
                    <div
                      v-for="(ito, indexito) in itemp.sku_list"
                      class="skuList"
                    >
                      <div style="">
                        <div>
                          <el-col :span="20">
                            <div style="display: flex; align-items: center">
                              <span>{{ ito.sku }}</span>
                              <div v-if="ito.is_abnormal">
                                <span
                                  class="blodClass"
                                  style="margin-left: 20px"
                                  >异常</span
                                >
                                <span
                                  class="blodClass"
                                  style="margin-left: 20px"
                                  >异常数量：{{ ito.abnormal_num }}</span
                                >
                                <span
                                  class="blodClass"
                                  style="margin-left: 20px"
                                  v-if="ito.remark"
                                  >异常备注：{{ ito.remark }}</span
                                >
                              </div>
                              <div v-if="ito.is_auto_cancel_deposit == 1">
                                <span
                                  class="blodClass"
                                  style="margin-left: 20px"
                                >自动取消寄存价格：{{  ito.auto_cancel_deposit_price}}</span>
                              </div>
                              <div v-if="ito.is_auto_cancel_deposit == 2">
                                <span
                                  class="blodClass"
                                  style="margin-left: 20px"
                                >主动取消寄存商品</span>
                              </div>
                            </div>
                          </el-col>
                        </div>
                        <div style="display: inline-block; margin-top: 10px">
                          <el-col :span="7">
                            <el-form-item label="单价：" label-width="60px">
                              <el-input
                                v-model="ito.one_price"
                                type="number"
                                size="mini"
                                @change="
                                  onchangePriceExpressRecovery(
                                    indexe,
                                    indexp,
                                    indexito
                                  )
                                "
                                v-if="
                                  ito.is_warehous_status > 0 &&
                                  ito.sku_product_return == 0 &&
                                  ito.sku_product_deposit == 0
                                "
                              />
                              <span
                                v-if="
                                  ito.is_warehous_status <= 0 ||
                                  ito.sku_product_return >= 1 ||
                                  ito.sku_product_deposit == 1
                                "
                                style="
                                  white-space: nowrap;
                                  display: block;
                                  width: 160px;
                                "
                                >{{ ito.one_price }}</span
                              >
                            </el-form-item>
                          </el-col>
                          <el-col :span="9">
                            <el-form-item
                              :label="'可结算数量：'"
                              label-width="90px"
                            >
                              <div style="position: relative">
                                <el-input
                                  v-model="ito.warehous_count"
                                  min="0"
                                  type="number"
                                  @change="
                                    onchangeNumExpressRecovery(
                                      indexe,
                                      indexp,
                                      indexito
                                    )
                                  "
                                  size="mini"
                                  v-if="
                                    ito.is_warehous_status > 0 &&
                                    ito.sku_product_return == 0 &&
                                    ito.sku_product_deposit == 0
                                  "
                                />
                                <span
                                  v-if="
                                    ito.is_warehous_status <= 0 ||
                                    ito.sku_product_return >= 1 ||
                                    ito.sku_product_deposit == 1
                                  "
                                  style="
                                    white-space: nowrap;
                                    display: block;
                                    width: 160px;
                                  "
                                  >{{
                                    ito.is_warehous_status <= 0 &&
                                    ito.sku_product_return == 0 &&
                                    ito.sku_product_deposit == 0
                                      ? 0 // 说明结算完毕，则可结算数量为 0
                                      : ito.sku_product_return >= 1
                                      ? ito.warehous_count -
                                        ito.sku_product_return
                                      : ito.sku_product_deposit == 1
                                      ? ito.warehous_count -
                                        ito.sku_product_deposit
                                      : ito.damage_count > 0
                                      ? ito.warehous_count - ito.damage_count
                                      : ito.warehous_count - ito.is_fail
                                  }}</span
                                >
                                <!-- 提醒文字 -->
                                <!--                                <span-->
                                <!--                                  style="-->
                                <!--                                    position: absolute;-->
                                <!--                                    bottom: 0;-->
                                <!--                                    white-space: nowrap;-->
                                <!--                                    left: 18%;-->
                                <!--                                    transform: translate(-50%, 23px) scale(0.9);-->
                                <!--                                    margin: 0;-->
                                <!--                                    font-size: 12px;-->
                                <!--                                    color: red;-->
                                <!--                                  "-->
                                <!--                                >-->
                                <!--                                  {{-->
                                <!--                                    `${-->
                                <!--                                      ito.damage_count > 0-->
                                <!--                                        ? "该数量已减去所有已处理异常数量"-->
                                <!--                                        : "该数量不包含假货异常数量，包含破损异常数量。请仔细核对"-->
                                <!--                                    }`-->
                                <!--                                  }}-->
                                <!--                                </span>-->
                              </div>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="总价：" label-width="60px">
                              <el-input
                                v-model="ito.warehous_price"
                                type="number"
                                @change="onchangeExpressRecovery"
                                size="mini"
                                v-if="
                                  ito.is_warehous_status > 0 &&
                                  ito.sku_product_return == 0 &&
                                  ito.sku_product_deposit == 0
                                "
                              />
                              <span
                                v-if="
                                  ito.is_warehous_status <= 0 ||
                                  ito.sku_product_return >= 1 ||
                                  ito.sku_product_deposit == 1
                                "
                                style="
                                  white-space: nowrap;
                                  display: block;
                                  width: 160px;
                                "
                                >{{ ito.warehous_price }}</span
                              >
                            </el-form-item>
                          </el-col>
                        </div>
                      </div>
                      <div style="display: inline-block">
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                          "
                          class="boxDetial"
                        >
                          <el-col :span="14">
                            <el-form-item label="备注：" label-width="60px">
                              <el-input
                                v-model="ito.sett_remark"
                                v-if="
                                  ito.is_warehous_status > 0 &&
                                  ito.sku_product_return == 0 &&
                                  ito.sku_product_deposit == 0
                                "
                                size="mini"
                              />
                              <span
                                v-if="
                                  ito.is_warehous_status <= 0 ||
                                  ito.sku_product_return >= 1 ||
                                  ito.sku_product_deposit == 1
                                "
                                >{{ ito.sett_remark }}</span
                              >
                            </el-form-item>
                          </el-col>
                          <el-col :span="16" v-if="ito.sku_product_return >= 1">
                            <div>已申请退回</div>
                          </el-col>
                          <el-col
                            :span="16"
                            v-if="
                              ito.sku_product_deposit == 1 &&
                              ito.sku_product_return == 0
                            "
                          >
                            <span>已全部寄存</span>
                          </el-col>
                          <!-- 没有可出库 -->
                          <el-col
                            :span="16"
                            v-if="
                              ito.is_warehous_status <= 0 &&
                              ito.sku_product_return == 0 &&
                              ito.sku_product_deposit == 0
                            "
                          >
                            <span style="white-space: nowrap">{{
                              "当前没有可结算数量"
                            }}</span>
                          </el-col>
                          <el-col
                            :span="10"
                            v-if="
                              ito.is_warehous_status > 0 &&
                              ito.sku_product_return == 0 &&
                              ito.sku_product_deposit == 0
                            "
                          >
                            <el-form-item label="">
                              <el-checkbox
                                v-model="ito.sett_check"
                                :true-label="1"
                                :false-label="0"
                                @change="onchangeExpressRecovery"
                              />
                            </el-form-item>
                          </el-col>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <el-col :span="24">
                  <el-form-item label="总数量：" v-if="status == 2">
                    <span>{{ recovery_num_total }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="总价格：" v-if="status == 2">
                    <span>{{ recovery_price_total }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item>
                    <el-button type="primary" @click="onSubmit">提交</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-if="recovery_order_id"
      title="异常处理"
      :visible.sync="visibleWornHandle"
      width="1000px"
      top="20px"
    >
      <order-worn-handle
        v-if="visibleWornHandle"
        ref="orderWornHandle"
        :recovery_order_id="recovery_order_id"
        @sendSuccess="sendSuccess"
      />
    </el-dialog>
    <el-dialog
      v-if="recovery_order_id"
      title="在库退回处理"
      :visible.sync="visibleReturnHandle"
      width="1000px"
    >
      <order-return-handle
        v-if="visibleReturnHandle"
        ref="orderReturnHandle"
        :recovery_order_id="recovery_order_id"
        @sendSuccess="sendSuccess"
      />
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from "@/settings";
import { fromList } from "@/libs/constants";
import {
  recoveryCategoryMenuListApi,
  recoveryOrderBatchSettApi,
  recoveryOrderCancelExpressApi,
  recoveryOrderCardListApi,
  recoveryOrderChartListApi,
  recoveryOrderDeleteApi,
  recoveryOrderDetailApi,
  recoveryOrderHandleReturnApi,
  recoveryOrderHandleWornApi,
  recoveryOrderListApi,
  recoveryOrderUpdateApi,
  recoveryOrderUpdateSublimitApi,
  recoveryStockCardListApi,
  orderDetailUpdate,
} from "@/api/recovery";
import cardsData from "@/components/cards";
import {
  appraisalEntityOrderCancelExpressApi,
  appraisalOrderEntityAuditApi,
} from "@/api/appraisal";
import { batchChangeGroupApi } from "@/api/user";
import orderWornHandle from "@/views/recovery/order/orderWornHandle";
import orderReturnHandle from "@/views/recovery/order/orderReturnHandle";
export default {
  name: "appraisalEntityOrder",
  components: { cardsData, orderWornHandle, orderReturnHandle },
  computed: {
    recoveryNum() {
      return function (data) {
        let nums = 0;
        data.product_list.map((item, index) => {
          item.sku_list.map((v, i) => {
            nums += Number(v.num);
          });
        });
        return nums;
      };
    },
    // 报单预估金额
    recovery_price() {
      let price = 0;
      this.formData.product_list.map((it, i) => {
        this.formData.product_list[i].sku_list.map((item, index) => {
          price += Number(item.price);
        });
      });
      return price;
    },
    wornStatusFn() {
      return function (status) {
        switch (status) {
          case 0:
            return "下单成功";
            break;
          case 1:
            return "已接单";
            break;
          case 9:
            return "已取消";
            break;
          case 10:
            return "已取件";
            break;
          case 13:
            return "已签收";
            break;
          case 14:
            return '异常签收';
          case 15:
            return '已结算';
          case 99:
            return '订单已取消'
          case 101:
            return '运输中'
          case 200:
            return '已出单'
          case 201:
            return '出单失败'
          case 601:
            return '下单失败'
          case 155:
            return '修改数量'
          case 166:
            return '订单复活'
          case 400:
            return '派送中'
          default:
            return '暂无'
        }
      };
    },
  },
  data() {
    return {
      props: { checkStrictly: true, emitPath: false },
      moren: require("@/assets/images/f.png"),
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      listLoading: true,
      wornLoadShow: false,
      tableData: {
        data: [],
        total: 0,
      },
      show: false,
      roterPre: roterPre,
      tableFrom: {
        recovery_uid: "moren",
        page: 1,
        limit: 20,
      },
      editNum: {},
      editObj: {},
      num: 1,
      order_update_type: 0,
      orderChartType: {},
      fromList: fromList,
      cardLists: [],
      timeVal: [],
      warehousTimeVal: [],
      type: "1",
      dialogVisible: false,
      dialogVisibleStatus: false,
      loading: false,
      formData: {
        product_list: [],
        order_return_list: [],
        user: {
          phone: "",
        },
      },
      expressItem: {},
      ruleForm: {},
      appraisal_order_id: "",
      recoveryCateList: [],
      formStatusData: [],
      status: "",
      statusList: [],
      recovery_price_total: 0,
      recovery_num_total: 0,
      chkName: "",
      checkedIds: [], // 订单当前页选中的数据
      noChecked: [], // 订单全选状态下当前页不选中的数据
      checkedPage: [],
      allCheck: false,
      cancel_time: null,
      recoveryOrderIdList: {
        recovery_order_id_list: [],
      },
      visibleWornHandle: false,
      visibleReturnHandle: false,
      recovery_order_id: 0,
      old_flag: 0,
    };
  },
  mounted() {
    this.getList(1);
    this.headerList();
    this.getCardList();
    this.checkedIds = [];
  },
  methods: {
    handleClose() {
      this.dialogVisibleStatus = false;
    },
    closeFn() {
      this.visibleWornHandle = false;
    },
    // 账户详情
    onWornHandle(id) {
      this.recovery_order_id = id;
      this.visibleWornHandle = true;
    },

    onReturnHandle(id) {
      this.recovery_order_id = id;
      this.visibleReturnHandle = true;
    },
    returnClose() {
      this.visibleWornHandle = false;
      this.visibleReturnHandle = false;
      this.getList(1);
    },
    sendSuccess() {
      this.visibleWornHandle = false;
      this.visibleReturnHandle = false;
      this.getList(1);
    },
    onHandle(name) {
      this.chkName = this.chkName === name ? "" : name;
      this.changeType(!(this.chkName === ""));
    },
    changeType(v) {
      if (v) {
        if (!this.chkName) {
          this.chkName = "dan";
        }
      } else {
        this.chkName = "";
        this.allCheck = false;
      }
      const index = this.checkedPage.indexOf(this.tableFrom.page);
      if (this.chkName === "dan") {
        this.checkedPage.push(this.tableFrom.page);
      } else if (index > -1) {
        this.checkedPage.splice(index, 1);
      }

      this.syncCheckedId();
    },
    syncCheckedId() {
      //   const ids = this.tableData.data.map(v => v.uid)
      const ids = this.tableData.data.map((v) => {
        if (!v.cancel_time) {
          return v.recovery_order_id;
        }
      });
      if (this.chkName === "duo") {
        this.checkedIds = [];
        this.allCheck = true;
      } else if (this.chkName === "dan") {
        this.allCheck = false;
        ids.forEach((id) => {
          const index = this.checkedIds.indexOf(id);
          if (index === -1) {
            this.checkedIds.push(id);
          }
        });
      } else {
        ids.forEach((id) => {
          const index = this.checkedIds.indexOf(id);
          if (index > -1) {
            this.checkedIds.splice(index, 1);
          }
        });
      }
    },
    // 分开选择
    changeOne(v, recovery) {
      if (v) {
        if (this.chkName === "duo") {
          const index = this.noChecked.indexOf(recovery.recovery_order_id);
          if (index > -1) this.noChecked.splice(index, 1);
        } else {
          const index = this.checkedIds.indexOf(recovery.recovery_order_id);
          if (index === -1) this.checkedIds.push(recovery.recovery_order_id);
        }
      } else {
        if (this.chkName === "duo") {
          const index = this.noChecked.indexOf(recovery.recovery_order_id);
          if (index === -1) this.noChecked.push(recovery.recovery_order_id);
        } else {
          const index = this.checkedIds.indexOf(recovery.recovery_order_id);
          if (index > -1) this.checkedIds.splice(index, 1);
        }
      }
    },
    batchGroup() {
      if (this.checkedIds.length === 0)
        return this.$message.warning("请先选择用户");
      this.recoveryOrderIdList.recovery_order_id_list = this.checkedIds;
      recoveryOrderBatchSettApi(this.recoveryOrderIdList)
        .then((res) => {
          this.$message.success(res.message);
          this.dialogVisibleStatus = false;
          this.checkedIds = [];
          this.getList("");
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    onSubmit() {
      this.loading = true;
      this.formStatusData.status = this.status;
      if (this.recovery_num_total == 0) {
        this.loading = false;
        this.$message.error("请选择需要结算的商品");
        return false;
      }
      recoveryOrderUpdateSublimitApi(
        this.formStatusData.recovery_order_id,
        this.formStatusData
      )
        .then((res) => {
          this.loading = false;
          this.$message.success(res.message);
          this.dialogVisibleStatus = false;
          this.getList("");
        })
        .catch((res) => {
          this.loading = false;
          this.$message.error(res.message);
        });
    },
    handleChange(e) {},
    /**
     * 确定修改数量
     * */
    async orderDetailUpdateFn() {
      let params = {
        order_update_type: this.order_update_type,
        type: this.type,
        num: this.num,
        recovery_category_id: this.editObj.recovery_category_id,
        sku: this.editObj.sku,
        recovery_order_id: this.formData.recovery_order_id,
        express_num: this.expressItem.express_num,
      };

      let data = await orderDetailUpdate(params);
      this.show = false;
      this.num = 1;
      this.type = "1";
      this.onDetail(this.formData.recovery_order_id);
    },
    /**
     * 修改数量
     * */
    editNumFn(item, row, type) {
      this.show = true;
      this.expressItem = item;
      this.editNum = row;
      this.editObj = row;
      this.order_update_type = type;
    },
    onchangeRecovery() {
      this.recovery_price_total = 0;
      this.recovery_num_total = 0;
      var product_list = this.formStatusData.product_list;
      product_list.forEach((item, index) => {
        var sku_list = item.sku_list;
        sku_list.forEach((it, ind) => {
          this.recovery_price_total += parseFloat(it.price);
          this.recovery_num_total = this.recovery_num_total + parseInt(it.num);
        });
      });
    },
    onchangePriceRecovery(indexp, indexito) {
      this.recovery_price_total = 0;
      this.recovery_num_total = 0;
      var product_list = this.formStatusData.product_list;
      product_list.forEach((item, index) => {
        var sku_list = item.sku_list;
        sku_list.forEach((it, ind) => {
          if (index == indexp && indexito == ind) {
            it.price = it.one_price * it.num;
          }
          this.recovery_price_total += parseFloat(it.price);
          this.recovery_num_total = this.recovery_num_total + parseInt(it.num);
        });
      });
    },
    onchangeNumRecovery(indexp, indexito) {
      this.recovery_price_total = 0;
      this.recovery_num_total = 0;
      var product_list = this.formStatusData.product_list;
      product_list.forEach((item, index) => {
        var sku_list = item.sku_list;
        sku_list.forEach((it, ind) => {
          if (index == indexp && indexito == ind) {
            it.price = it.one_price * it.num;
          }
          this.recovery_price_total += parseFloat(it.price);
          this.recovery_num_total = this.recovery_num_total + parseInt(it.num);
        });
      });
    },
    onchangeExpressRecovery() {
      this.recovery_price_total = 0;
      this.recovery_num_total = 0;
      var express_list = this.formStatusData.express_list;
      express_list.forEach((iteme, indexe) => {
        var product_list = iteme.product_list;
        if(product_list){
          product_list.forEach((item, index) => {
            var sku_list = item.sku_list;
            sku_list.forEach((it, ind) => {
              if (it.sett_check == 1) {
                this.recovery_price_total += parseFloat(it.warehous_price);
                this.recovery_num_total =
                  this.recovery_num_total + parseInt(it.warehous_count);
              }
            });
          });
        }
      });
    },
    onchangePriceExpressRecovery(indexe, indexp, indexito) {
      this.recovery_price_total = 0;
      this.recovery_num_total = 0;
      var express_list = this.formStatusData.express_list;
      express_list.forEach((iteme, indexex) => {
        var product_list = iteme.product_list;
        product_list.forEach((item, index) => {
          var sku_list = item.sku_list;
          sku_list.forEach((it, ind) => {
            if (indexex == indexe && index == indexp && indexito == ind) {
              it.warehous_price = it.one_price * it.warehous_count;
            }
            if (it.sett_check == 1) {
              this.recovery_price_total += parseFloat(it.warehous_price);
              this.recovery_num_total =
                this.recovery_num_total + parseInt(it.warehous_count);
            }
          });
        });
      });
    },
    onchangeNumExpressRecovery(indexe, indexp, indexito) {
      this.recovery_price_total = 0;
      this.recovery_num_total = 0;
      var express_list = this.formStatusData.express_list;
      express_list.forEach((iteme, indexex) => {
        var product_list = iteme.product_list;
        product_list.forEach((item, index) => {
          var sku_list = item.sku_list;
          sku_list.forEach((it, ind) => {
            if (indexex == indexe && index == indexp && indexito == ind) {
              it.warehous_price = it.one_price * it.warehous_count;
            }
            if (it.sett_check == 1) {
              this.recovery_price_total += parseFloat(it.warehous_price);
              this.recovery_num_total =
                this.recovery_num_total + parseInt(it.warehous_count);
            }
          });
        });
      });
    },
    recoveryMenuCategory() {
      recoveryCategoryMenuListApi(2)
        .then((res) => {
          this.recoveryCateList = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    // 详情
    onDetail(id) {
      this.appraisal_order_id = id;
      this.dialogVisible = true;
      this.isExamine = false;
      recoveryOrderDetailApi(id)
        .then((res) => {
          this.formData = res.data;
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
    // 编辑
    onEdit(id) {
      //this.$modalForm(recoveryOrderUpdateApi(id)).then(() => this.getList(''))
      this.formData = {
        product_list: [],
        order_return_list: [],
        user: {
          phone: "",
        },
      };
      this.formStatusData = {};
      this.dialogVisibleStatus = true;
      this.isExamine = false;
      this.loading = true;
      recoveryOrderDetailApi(id)
        .then((res) => {
          this.formData = res.data;
          recoveryOrderUpdateApi(id)
            .then((res) => {
              console.log(res, "------------");
              this.formStatusData = res.data.data;
              this.formStatusData.recovery_num = 0;
              this.formStatusData.recovery_price = 0;
              this.status = res.data.status;
              this.old_flag = res.data.old_flag;
              this.statusList = res.data.statusList;
              this.recovery_price_total = this.formStatusData.recovery_price;
              this.recovery_num_total = this.formStatusData.recovery_num;
              this.loading = false;
            })
            .catch(({ message }) => {
              console.log(res, "錯誤");
              this.$message.error(message);
              this.loading = false;
            });
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
    headerList() {
      recoveryOrderChartListApi()
        .then((res) => {
          this.orderChartType = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    // 选择时间
    selectChange(tab) {
      this.tableFrom.date = tab;
      this.tableFrom.page = 1;
      this.timeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.date = e ? this.timeVal.join("-") : "";
      this.tableFrom.page = 1;
      this.getList(1);
    },

    // 选择时间
    selectWarehousChange(tab) {
      this.tableFrom.warehous_date = tab;
      this.tableFrom.page = 1;
      this.warehousTimeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeWarehousTime(e) {
      this.warehousTimeVal = e;
      this.tableFrom.warehous_date = e ? this.warehousTimeVal.join("/") : "";
      this.tableFrom.page = 1;
      this.getList(1);
    },
    // 列表
    getList(num) {
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.appraisal_type_list = 1;
      recoveryOrderListApi(this.tableFrom)
        .then((res) => {
          this.tableData.data = res.data.list;
          this.tableData.total = res.data.count;
          this.headerList();
          this.getCardList();
          this.checkedIds = [];
          this.listLoading = false;
        })
        .catch((res) => {
          this.listLoading = false;
          this.$message.error(res.message);
        });
    },
    pageChange(page) {
      this.tableFrom.page = page;
      this.getList("");
    },
    handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList("");
    },
    // 删除
    handleDelete(id, idx) {
      this.$modalSure().then(() => {
        recoveryOrderDeleteApi(id)
          .then(({ message }) => {
            this.$message.success(message);
            this.getList();
          })
          .catch(({ message }) => {
            this.$message.error(message);
          });
      });
    },
    handleReturnHandle(id, idx) {
      this.$modalSure().then(() => {
        recoveryOrderHandleReturnApi(id)
          .then(({ message }) => {
            this.$message.success(message);
            this.getList();
          })
          .catch(({ message }) => {
            this.$message.error(message);
          });
      });
    },
    //取消异常订单
    handleWornHandle(id, idx) {
      this.$modalSure().then(() => {
        recoveryOrderHandleWornApi(id)
          .then(({ message }) => {
            this.$message.success(message);
            this.getList();
          })
          .catch(({ message }) => {
            this.$message.error(message);
          });
      });
    },
    //取消寄件
    onCancelExpress(id, idx) {
      this.$modalSure("确定取消寄件吗？").then(() => {
        recoveryOrderCancelExpressApi(id)
          .then(({ message }) => {
            this.$message.success(message);
            this.getList("");
          })
          .catch(({ message }) => {
            this.$message.error(message);
          });
      });
    },
    getCardList() {
      recoveryOrderCardListApi(this.tableFrom)
        .then((res) => {
          this.cardLists = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.boxDetial .el-form-item {
  margin-bottom: 0px;
}
/deep/.el-form-item {
  /*margin-bottom: 0!important;*/
}
.box-container {
  overflow: hidden;
}

.box-container .list {
  float: left;
  line-height: 40px;
}

.box-container .sp {
  width: 50%;
}

.box-container .sp3 {
  width: 33.3333%;
}

.box-container .sp100 {
  width: 100%;
}
.decla_row {
  width: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin: 40px 0 0;
  padding: 20px 20px 0;
  box-sizing: border-box;
}
.batch_num {
  color: red;
  font-size: 16px;
}
.decla_title {
  font-size: 16px;
  font-weight: bold;
}
.box-container .list .name {
  display: inline-block;
  width: 150px;
  text-align: right;
  color: #606266;
}
.skuList {
  border-bottom: 2px solid #f4f4f5;
  margin-bottom: 10px;
}
.blodClass {
  font-size: 14px;
  color: red;
  font-weight: bold;
}
.box-container .list.image {
  margin-bottom: 40px;
}

.box-container .list.image img {
  position: relative;
  top: 40px;
}

/deep/ .el-form-item__content .el-rate {
  position: relative;
  top: 8px;
}
.cate_name {
  width: 200px;
}
.sku-tb {
  border: 1px solid black;
  border-collapse: collapse;
  margin-bottom: 20px;
  width: 100%;
  tr {
    th,
    td {
      border: 1px solid black;
      text-align: center;

      .sku-name {
        margin: 0 auto;
        width: 100px;
        /*height: 30px;*/
        /*overflow: hidden;*/
        line-height: 24px;
        text-overflow: ellipsis;
        /*word-break: keep-all;*/
      }
    }
  }
}
</style>
